import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import map from 'lodash/map';

const RadioGroupContainer = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.57;
  letter-spacing: 0.3px;
  margin-bottom: 8px;
  color: ${(props) => (props.valid === false ? '#f74656' : '#354354')};
`;

const RadioGroupField = styled.div`
  display: flex;
`;

const Radio = styled.div`
  ${(props) => props.small
    ? `
    height: 30px;
    min-width: 60px;
    padding: 0 18px;
  `
    : `
    height: ${props.height ? props.height : '48px'};
    min-width: ${props.minWidth ? props.minWidth : '100px'};
    padding: ${props.padding ? props.padding : '0 30px'};
  `}
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${(props) => props.fontSize ? props.fontSize : '16px'};
  letter-spacing: 0.1px;
  color: ${(props) => props.color ? props.color : '#979ea7'};
  ${(props) => props.isActive
    ? `
    background-color: ${props.activeBackgroundColor ? props.activeBackgroundColor : '#4a90e2'};
    color: ${props.activeColor ? props.activeColor : '#ffffff'};
  `
    : `
    background-color: ${props.backgroundColor ? props.backgroundColor : '#f4f7f9'};
    &:hover {
      opacity: 0.8;
    }
  `}
  &:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  &:last-child {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  & + & {
    border-left: 1px solid rgba(0,0,0,0.07);
  }
`;

class RadioGroup extends Component {
  render() {
    const {
      label, options, small, currentOption, onOptionChange,
      height, minWidth, padding, fontSize, color, activeBackgroundColor, activeColor, backgroundColor,
    } = this.props;

    return (
      <RadioGroupContainer>
        {label && <Label>{label}</Label>}
        <RadioGroupField>
          {map(options, (option, index) => (
            <Radio
              key={`Radio${index}`}
              small={small}
              isActive={currentOption === option.value}
              onClick={() => onOptionChange(option.value)}
              height={height}
              minWidth={minWidth}
              padding={padding}
              fontSize={fontSize}
              color={color}
              activeBackgroundColor={activeBackgroundColor}
              activeColor={activeColor}
              backgroundColor={backgroundColor}
            >
              {option.text}
            </Radio>
          ))}
        </RadioGroupField>
      </RadioGroupContainer>
    );
  }
}

RadioGroup.propTypes = {
  label: PropTypes.string,
  small: PropTypes.bool,
  options: PropTypes.array,
  currentOption: PropTypes.string,
  onOptionChange: PropTypes.func,
  height: PropTypes.string,
  minWidth: PropTypes.string,
  padding: PropTypes.string,
  fontSize: PropTypes.string,
  color: PropTypes.string,
  activeBackgroundColor: PropTypes.string,
  activeColor: PropTypes.string,
  backgroundColor: PropTypes.string,
};

RadioGroup.defaultProps = {
  label: '',
  small: false,
  options: [],
  currentOption: '',
  onOptionChange: () => {},
  height: '',
  minWidth: '',
  padding: '',
  fontSize: '',
  color: '',
  activeBackgroundColor: '',
  activeColor: '',
  backgroundColor: '',
};

export default RadioGroup;
